import React from 'react';
import { connect } from 'react-redux';
import { RadioButton, Checkbox } from 'material-ui';
import ArrowForward from 'material-ui/svg-icons/navigation/arrow-forward';
import RateNameText from './preview-rate-name-text';
import Extras from './preview-extras';
import AgePolicies from './preview-age-policies';
import RoomPolicies from './preview-room-policies';
import DiscrepancyMsg from './preview-discrepancy-msg-box';
import TwoColumnRow from '../../../tc-ui/two-column-row';

import R from 'ramda';
import PreviewNotes from './preview-notes';

// extraProps has policies, extraLines, pickedExtras, notPickedExtras, updateWithKeyPath, discrepancyMsg, sendMsg
const ExportContentPreview = ({ productName, mapping, tourplanName, style, stayPayExists, ChargeExtras, ...extraProps }) => {
  return (
    <div style={style}>
      <div style={{ display: 'flex', paddingLeft: '16px', alignItems: 'center', minHeight: '56px', borderBottom: '1px solid #e0e0e0' }}>
        {
          Array.isArray(productName) ? (
            <div style={{ whiteSpace: 'pre-wrap' }}>
              {productName.join(`\n`)}
            </div>
          ) : productName
        }
        <ArrowForward style={{ fontSize: '15px', margin: '0 5px', top: '2px' }} color={"#c8c8c8"}/>
        {` ${tourplanName} (${mapping})`}
      </div>
      <div style={{ padding: '16px', borderBottom: '1px solid #e0e0e0' }}>
        <label>Edit Rule:</label>
        <RadioButton
          label="Changes apply to one field only"
          checked={!extraProps.editCarriesTo}
          onCheck={() => extraProps.updateWithKeyPath(['editCarriesTo'], null)}
        />
        <RadioButton
          label="Changes apply to similar seasons within a product"
          checked={extraProps.editCarriesTo === 'sameProduct'}
          onCheck={() => extraProps.updateWithKeyPath(['editCarriesTo'], 'sameProduct')}
        />
        <RadioButton
          label="Changes apply to similar seasons across all products"
          checked={extraProps.editCarriesTo === 'sameSeasonAcrossProducts'}
          onCheck={() => extraProps.updateWithKeyPath(['editCarriesTo'], 'sameSeasonAcrossProducts')}
        />
        <RadioButton
          label="Changes apply to same field across all products"
          checked={extraProps.editCarriesTo === 'sameFieldAllSeasonsAllProducts'}
          onCheck={() => extraProps.updateWithKeyPath(['editCarriesTo'], 'sameFieldAllSeasonsAllProducts')}
        />
      </div>
      <TwoColumnRow
        outerContainerStyle={{ display: 'flex', padding: '16px' }}
        leftColumnStyle={{ width: '35%' }}
        leftColumnContent={<RateNameText {...extraProps} />}
        rightColumnStyle={{ width: '65%', marginLeft: '2%' }}
        rightColumnContent={<div>
          <Extras {...extraProps} />
          {
            Boolean(stayPayExists && R.values(extraProps.extraLines).filter(x => x).length) && (
              <div style={{ margin: '3em auto' }}>
                <div style={{ display: 'flex', width: '100%' }}>
                  <div style={{ width: '20%' }}/>
                  <div style={{ textAlign: 'center', fontWeight: 'bold', paddingBottom: '16px', fontSize: '18px', width: '80%', borderBottom: '1px solid black' }}>
                    Charge extras on FOC night for Stay Pay
                  </div>
                </div>
                <div style={{ display: 'flex', width: '100%', marginTop: '1em' }}>
                  <div style={{ width: '40%' }}/>
                  <div style={{ width: '40%' }}>
                  {
                    R.values(extraProps.extraLines).map((line, i) => line ? (
                      (
                        <Checkbox
                          key={i}
                          label={line}
                          checked={ChargeExtras[`ChargeExtra${i + 1}`] === 'Y'}
                          onCheck={(_, checked) => extraProps.updateThisProductWithKeyPath(['ChargeExtras', `ChargeExtra${i + 1}`], checked ? 'Y' : 'N')}
                        />
                      )
                    ) : <div key={i}/>)
                  }
                  </div>
                </div>
              </div>
            )
          }
          <PreviewNotes {...extraProps}/>
          <RoomPolicies {...extraProps} />
          <AgePolicies {...extraProps} />
          <DiscrepancyMsg {...extraProps} />
        </div>}
      />
    </div>);
};

const mapStateToProps = ({ integration }) => ({
  convertedContract: integration.get('convertedContract') ? integration.get('convertedContract').toJS() : [],
});

export default connect(mapStateToProps)(ExportContentPreview);



// WEBPACK FOOTER //
// ./src/app/components/integration/export/export-content-preview/single-product-preview.jsx